<template>
    <!-- <loading v-if="loading"></loading> -->
    <div class="ai">
        <div class="release" v-loading="loading" element-loading-text="拼命加载中">
            <forumItem @postLike="postLike" @collect="collect" v-for="(item,index) in list" :item="item" :key="index" @goDetails="goDetails" :isDel="true" @del="del"></forumItem>
            <noData v-if="noData&&!loading"></noData>
            <p v-if="noMore && !noData">已经到底了~</p>
        </div>
    </div>
</template>
<script>
import forumItem from '@/components/forum-item/index.vue'
import request from "@/utils/request";
import {diffTime} from '@/utils/common.js';
import loading from '@/components/loading/loading.vue'
import noData from '@/components/noData/index.vue'
import Cookies from 'js-cookie'
export default {
    components: {forumItem,loading,noData},
    data(){
        return{
            noData:false,
            loading:true,
            list:[],
            query:{
                page:1,
                limit:10,
                type:4,
                user_id:JSON.parse(localStorage.getItem('userInfo')).id
            },
            noMore:false
        }
    },
    created(){
        if(localStorage.getItem("userInfo")){
            this.getList()
        }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);  // 监听（绑定）滚轮滚动事件
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);   //  离开页面清除（移除）滚轮滚动事件
    },
    methods:{
        handleScroll() {
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
               //滚动条到底部的条件
            if(scrollTop+windowHeight==scrollHeight){
               if(!this.noMore){
                    console.log('触底')
                    this.query.limit += 10
                    this.getList()
                }
                //写后台加载数据的函数
                // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
            }          
        },
         // 帖子点赞
        postLike(id) {
            request({
                url: "/api/userend/post/postLike",
                method: "post",
                params: {forum_post_id:id}
            }).then(response => {
                let index = this.list.findIndex(item=>{
                    return item.id==id
                })
                this.list[index].is_like=!this.list[index].is_like
                if(this.list[index].is_like==0){
                    this.list[index].like_num-=1
                }else{
                    this.list[index].like_num+=1
                }
            });
        },
         // 帖子收藏
        collect(id) {
            request({
                url: "/api/userend/post/collect",
                method: "post",
                params: {id:id}
            }).then(response => {
                let index = this.list.findIndex(item=>{
                    return item.id==id
                })
                this.list[index].is_collect=!this.list[index].is_collect
            });
        },
        goDetails(id){
            this.$router.push(
                {
                    path:"/forum/forumDetails",
                    query:{
                        forum_post_id:id
                    }
                }
            )
        },
         // 我的发布
        getList() {
            this.loading = true;
            request({
                url: "/api/userend/post/postList",
                method: "get",
                params: this.query
            }).then(response => {
                response.data.forEach(item => {
                    item.dateTime = diffTime(item.created_at)
                });
                this.list=response.data
                if(response.data==0){
                    this.noData=true
                }
                if(this.list.length < this.query.limit){
                    this.noMore=true
                }
                this.loading = false;
            });
        },
        // 删除
        del(id){
            this.$confirm('此操作将永久删除帖子, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //点击确定的操作(调用接口)
                request({
                    url: "/api/userend/post/removePost",
                    method: "post",
                    params: {forum_post_id:id}
                }).then(response => {
                    this.$message.success("删除成功")
                    this.getList()
                });
            }).catch(() => {
                //几点取消的提示
            });
        }
    }
}
</script>
<style lang="scss">
.ai{
  .release{
        background: #ffffff;
        padding: 0 30px;
        border-radius: 8px;
        p{
            text-align: center;
            padding: 5px 0 15px 15px;
        }
    }
    .el-loading-spinner{
        position: fixed;
        top: 400px;
        left: 230px;

    }
}
</style>